import { useEffect, useState,useRef } from "react";  
import { getPrincipalMessage } from "../Service/Api"; 
import LazyLoad from "react-lazyload";
const HomeMessage = () => {

   const [data, setData] = useState([]);
   useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getPrincipalMessage();
        console.log(data)
        setData(data);
      } catch (error) {
        console.error("Error fetching online registration data:", error);
      }  
    };
    fetchData();
  }, []);

  const videoRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const handlePlay = () => {
    setIsOpen(true); // Open the popup 
  };
 

  const handleClose = () => {
    setIsOpen(false); // Close the popup 
  };
   return (
      <>
         <section className="lcsd-choose-area">
            <div className="lcsd-choose-wrap">
               <div className="container"> 
               <div className="row">
                  <div className="col-lg-12">
                  <div class="section-title text-center"> 
                        <div class="section-title__sub-title-box"> 
                        <p class="section-title__sub-title text-center"> From The Desk  </p> </div> 
                        <h2 class="section-title">Principal Message</h2> </div> 
                  </div>
                  </div>
                  {data.length > 0 && (
                     <div className="row">
                     <div class="col-xl-8 col-lg-7 order-2 order-lg-1"> 
                           <div class="lcsd-choose-contain">
                                <blockquote class="lcsd-choose-contain-qoute"> 
                                   <div dangerouslySetInnerHTML={{ __html: data[0].message }} />
                                </blockquote>
                                <p class="designation"><b>{data[0].name}</b> <br /><span>{data[0].category}</span></p>
                           </div>
                           <div class="why-choose-three__btn-box"> <a href="/PrincipalMessage" class="thm-btn"> Read More</a> </div>
                     </div> 
                     <div className="col-xl-4 col-lg-5 order-1 order-lg-2">
                           <div className="lcsd-choose-img bg-default">
                              <LazyLoad><img src={`https://webapi.entab.info/api/image/${data[0].attachments}`} className="img-fluid" /></LazyLoad>
                           </div>
                           <div class="why-choose-three__btn-box"> <button class="thm-btn" onClick={handlePlay}> Watch Message Video </button> </div>
                        </div>
                     </div> 
                  )} 
                  {data.length === 0  && (
                     <div className="row">
                     <div class="col-xl-8 col-lg-7 order-2 order-lg-1"> 
                       <div class="lcsd-choose-contain"> 
                          <blockquote class="lcsd-choose-contain-qoute">  
                         <p>Dear Students, Parents, and Staff,</p>
                        <div>
                              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. 
                       </div>
                      </blockquote> 
                      <p class="designation"><b>Principal's Name</b> <br /><span>Principal</span></p>
                     </div> 
                     </div>
                      <div className="col-xl-4 col-lg-5 order-1 order-lg-2">
                         <div className="lcsd-choose-img bg-default">
                            <LazyLoad><img src="https://webapi.entab.info/api/image/SHSSB/public/Images/principal.jpg" className="img-fluid" /></LazyLoad>
                         </div>
                         <div class="why-choose-three__btn-box"> <a href="/PrincipalMessage" class="thm-btn"> Read More</a> </div>
                      </div>
                     </div>
                      )}
               </div>
            </div>
         </section>
         {isOpen && (
            <div className="video-popup">
            <div className="video-popup-content">
                <button className="close-button" onClick={handleClose}>×</button> 
                 <video width="100%" height="100%" loop controls autoPlay>
                     <source src="https://webapi.entab.info/api/image/SHSSB/public/Images/principalvideo.mp4" type="video/mp4"/>
                     <source src="https://webapi.entab.info/api/image/SHSSB/public/Images/principalvideo.ogg" type="video/ogg"/> 
                  </video>
                </div>
            </div>
          )}
      </>
   )
}

export default HomeMessage